export function uniqArray<T>(arr: T[]) {
	return Array.from(new Set(arr));
}
